import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '@/shared/store/store';
import { adminLogoutRequest } from '@/features/security/sagas/admin-slice';

export const useAdminAuth = () => {
  const dispatch = useDispatch<AppDispatch>();
  const adminState = useSelector((state: RootState) => state.admin);

  const logout = async () => {
    dispatch(adminLogoutRequest());
  };

  return {
    isAuthenticated: adminState.isAuthenticated,
    user: adminState.user,
    token: adminState.token,
    refreshToken: adminState.refreshToken,
    loading: adminState.loading,
    error: adminState.error,
    permissions: adminState.permissions,
    role: adminState.role,
    logout,
  };
};
